import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";

var _class, _descriptor, _temp;

import { action, observable } from "mobx";

/* istanbul ignore next: Example implementations gets deleted the most time after plugin creation! */
var ApiKeyStore = (_class = (_temp = /*#__PURE__*/function () {
  function ApiKeyStore(rootStore) {
    _classCallCheck(this, ApiKeyStore);

    _initializerDefineProperty(this, "apiKey", _descriptor, this);

    this.rootStore = void 0;
    this.rootStore = rootStore;
  }

  _createClass(ApiKeyStore, [{
    key: "setApiKey",
    value: function setApiKey(apiKey) {
      this.apiKey = apiKey;
    }
  }]);

  return ApiKeyStore;
}(), _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "apiKey", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setApiKey", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setApiKey"), _class.prototype)), _class);
export { ApiKeyStore };